// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7b814ada","450":"0c7a7061"}[chunkId] + ".chunk.js";
};